export function formatColor ([h, s, l]) {
  return `hsl(${h}, ${s}%, ${l}%)`;
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function hslToHex ([h, s, l]) {
  s /= 100;
  l /= 100;

  let r, g, b;

  if (s === 0) {
    r = g = b = Math.round(l * 255);
  } else {
    const hueToRgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = Math.round(hueToRgb(p, q, h / 360 + 1 / 3) * 255);
    g = Math.round(hueToRgb(p, q, h / 360) * 255);
    b = Math.round(hueToRgb(p, q, h / 360 - 1 / 3) * 255);
  }

  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export function totallyRandom () {
  // 0
  return {palette: [
    [Math.floor(Math.random() * 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [Math.floor(Math.random() * 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [Math.floor(Math.random() * 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)]
  ], info: ["Totally random", "Three random colors, no rules applied"], key: 0};
}

export function monochromaticTints () {
  // 1 
  const h = getRandomInt(0, 360);
  const s = getRandomInt(0, 100);
  const l = getRandomInt(33, 66);

  return {palette: [
    [h, s, Math.max(0, l - getRandomInt(9, 34))],
    [h, s, l],
    [h, s, Math.min(100, l + getRandomInt(9, 34))]
  ], info: ["Monochromatic tints", "Three colors with the same random hue and saturation, the lightness is increased"], key: 1};
}

export function monochromaticShades () {
  // 2
  const h = getRandomInt(0, 360);
  const s = getRandomInt(0, 100);
  const l = getRandomInt(33, 66);

  return {palette: [
    [h, s, Math.min(100, l + getRandomInt(9, 34))],
    [h, s, l],
    [h, s, Math.max(0, l - getRandomInt(9, 34))]
  ], info: ["Monochromatic shades", "Three colors with the same random hue and saturation, the lightness is decreased"], key: 2};
}

export function tightAnalogous() {
  // 3
  const h = getRandomInt(0, 360);
  const offset = getRandomInt(15, 30);

  const result = Math.random() < 0.5 ? {palette: [
    [(h + offset) % 360, getRandomInt(10, 90), getRandomInt(0, 50)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 360 - offset) % 360, getRandomInt(10, 90), getRandomInt(76, 100)]
  ], info: ["Tight analogous", "Three colors with hues 15°- 30° apart, random saturation and different lightness."], key: 3} :{palette: [
    [(h + 360 - offset) % 360, getRandomInt(10, 90), getRandomInt(76, 100)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + offset) % 360, getRandomInt(10, 90), getRandomInt(10, 50)]
  ], info: ["Tight analogous", "Three colors with hues 15°- 30° apart, random saturation and different lightness."], key: 3}
  
  return result
}

export function standardAnalogous() {
  // 4
  const h = getRandomInt(0, 360);

  const result = Math.random() < 0.5 ? {palette: [
    [(h + 30) % 360, getRandomInt(10, 90), getRandomInt(0, 50)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 360 - 30) % 360, getRandomInt(10, 90), getRandomInt(76, 100)]
  ], info: ["Standard analogous", "Three colors with hues 30° apart, random saturation and different lightness."], key: 4} :{palette: [
    [(h + 360 - 30 ) % 360, getRandomInt(10, 90), getRandomInt(76, 100)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 30) % 360, getRandomInt(10, 90), getRandomInt(10, 50)]
  ], info: ["Standard analogous", "Three colors with hues 30° apart, random saturation and different lightness."], key: 4}
  
  return result
}

export function wideAnalogous() {
  // 5
  const h = getRandomInt(0, 360);
  const s = getRandomInt(0, 100);
  const offset = getRandomInt(30, 60);

  const result = Math.random() < 0.5 ? {palette: [
    [(h + offset) % 360, getRandomInt(10, 90), getRandomInt(0, 50)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 360 - offset) % 360, getRandomInt(10, 90), getRandomInt(76, 100)]
  ], info: ["Wide analogous", "Three colors with hues 30° - 60° apart, random saturation and different lightness."], key: 5} :{palette: [
    [(h + 360 - offset) % 360, getRandomInt(10, 90), getRandomInt(76, 100)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + offset) % 360, getRandomInt(10, 90), getRandomInt(10, 50)]
  ], info: ["Wide analogous", "Three colors with hues 30° - 60° apart, random saturation and different lightness."], key: 5}
  
  return result
}



export function triadic() {
  // 6
  const h = getRandomInt(0, 360);

  const result = Math.random() < 0.5 ? {palette: [
    [(h + 120) % 360, getRandomInt(10, 90), getRandomInt(0, 50)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 240) % 360, getRandomInt(10, 90), getRandomInt(76, 100)]
  ], info: ["Triadic", "Three colors with hues evenly spaced around the color wheel (120° apart), random saturation and different lightness."], key: 6} :{palette: [
    [(h + 240) % 360, getRandomInt(10, 90), getRandomInt(76, 100)], 
    [h, getRandomInt(10, 90), getRandomInt(51, 75)],
    [(h + 120) % 360, getRandomInt(10, 90), getRandomInt(10, 50)]
  ], info: ["Triadic", "Three colors with hues evenly spaced around the color wheel (120° apart), random saturation and different lightness."], key: 6} 

  return result 
}


export function randomWarm () {
  // 7
  return {palette: [
    [getRandomInt(0, 120), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(0, 120), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(0, 120), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)]
  ], info: ["Random warm", "Three random warm hues (h: 0°- 120°), random saturation and lightness, no other rules applied"], key: 7};
}

export function randomCool () {
  // 8
  return {palette: [
    [getRandomInt(120, 240), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(120, 240), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(120, 240), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)]
  ], info: ["Random cool", "Three random cool hues (h: 120°- 240°), random saturation and lightness, no other rules applied"], key: 8};
}

export function randomViolets () {
  // 9
  return {palette: [
    [getRandomInt(240, 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(240, 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)],
    [getRandomInt(240, 360), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)]
  ], info: ["Random violets", "Three random violet hues (h: 240°- 360°), random saturation and lightness, no other rules applied"], key: 9};
}

export function ninetyDegRotation() {
  // 10
  const h = getRandomInt(0, 360);

  const result = Math.random() < 0.5 ? {palette: [
    [(h + 90) % 360, getRandomInt(0, 100), getRandomInt(0, 50)], 
    [h, getRandomInt(0, 100), getRandomInt(51, 75)],
    [(h + 360 - 90) % 360, getRandomInt(0, 100), getRandomInt(76, 100)]
  ], info: ["90° Rotation", "Three colors with hues evenly spaced around the color wheel 90° apart, random saturation and different lightness."], key: 10} :{palette: [
    [(h + 360 - 90 ) % 360, getRandomInt(0, 100), getRandomInt(76, 100)], 
    [h, getRandomInt(0, 100), getRandomInt(51, 75)],
    [(h + 90) % 360, getRandomInt(0, 100), getRandomInt(10, 50)]
  ], info: ["90° Rotation", "Three colors with hues evenly spaced around the color wheel 90° apart, random saturation and different lightness."], key: 10}
  
  return result
}

export function complementaryAccent() {
  // 11
  const h = getRandomInt(0, 360);

  const result = Math.random() < 0.5 ? {palette: [
    [h, getRandomInt(5, 95), getRandomInt(5, 50)], 
    [h, getRandomInt(5, 95), getRandomInt(51, 95)],
    [(h + 180) % 360, getRandomInt(10, 90), getRandomInt(15, 85)]
  ], info: ["Complementary Accent", "Similar hue in the Primary and Support and a complementary hue for the Accent, random saturation and different lightness."], key: 11} :{palette: [
    [h, getRandomInt(5, 95), getRandomInt(51, 95)], 
    [h, getRandomInt(5, 95), getRandomInt(5, 50)],
    [(h + 180) % 360, getRandomInt(10, 90), getRandomInt(15, 85)]
  ], info: ["Complementary Accent", "Similar hue in the Primary and Support and a complementary hue for the Accent, random saturation and different lightness."], key: 11}
  
  return result
}

export function complementaryPnSGrayscaleAccent() {
  // 12
  const h = getRandomInt(0, 360);

  const result = {palette: [
     
    [h, getRandomInt(5, 95), getRandomInt(5, 95)],
    [(h + 180) % 360, getRandomInt(5, 95), getRandomInt(5, 95)],
    [0, 0, getRandomInt(0, 100)]
  ], info: ["Complementary Primary and Support, Grayscale Accent", "Primary and Support are complementary hues with random saturation and lightness, Accent is a random grayscale color."], key: 12}
    
  
  return result
}

export function splitComplementary() {
  // 13
  const h = getRandomInt(0, 360);

    const result = Math.random() < 0.5 ? {palette: [
     
    
    [(h + 150) % 360, getRandomInt(5, 95), getRandomInt(10, 90)],
    [(h + 210) % 360, getRandomInt(5, 95), getRandomInt(10, 90)],
    [h, getRandomInt(5, 95), getRandomInt(10, 90)],
  ], info: ["Split-Complementary", "Primary and Support share close hues and random saturaion and lightness, the Accent is Complementary with random saturaion and lightness"], key: 13} :{palette: [
    
    [(h + 210) % 360, getRandomInt(5, 95), getRandomInt(10, 90)],
    [(h + 150) % 360, getRandomInt(5, 95), getRandomInt(10, 90)],
    [h, getRandomInt(5, 95), getRandomInt(10, 90)],
  ], info: ["Split-Complementary", "Primary and Support share close hues and random saturaion and lightness, the Accent is Complementary with random saturaion and lightness"], key: 13}
  
  return result
}



export function randomPalette(key) { 
  const generators = [totallyRandom, monochromaticTints, monochromaticShades, tightAnalogous, standardAnalogous, wideAnalogous, triadic, randomWarm, randomCool, randomViolets, ninetyDegRotation, complementaryAccent, complementaryPnSGrayscaleAccent, splitComplementary];
  if(key) {
      
      return generators[key]();

  } else {
    const randomKey = getRandomInt(0, 13);
    return generators[randomKey](); 
  }



}